import { Injectable } from '@angular/core';
import { getHourlyForecastRunDatesLoaded } from '@firebird-web/hourly-forecast-run-dates-store';
import { LocalStorageService } from '@firebird-web/shared-services';
import { Store } from '@ngrx/store';
import { LocalStorageKeysEnum } from 'libs/shared/enums';
import {
  animationFrameScheduler,
  filter,
  first,
  observeOn,
  ReplaySubject,
  startWith,
  Subject,
  switchMap,
  timer,
} from 'rxjs';
import { getRunDatesLoaded } from '../+state/run-dates/run-dates.selectors';

@Injectable({
  providedIn: 'root',
})
export class RunDatesRefreshService {
  public midnightUpdateTrigger$ = new Subject<boolean>();
  public isReloaded$ = new ReplaySubject(1).pipe(startWith(true), first());

  public get isLastRunDateSelected() {
    return (
      this.localStorageService.getValue(
        LocalStorageKeysEnum.IsLastRunDateSelected
      ) === 'true'
    );
  }

  public set isLastRunDateSelected(isRunDateSelected: boolean) {
    this.localStorageService.setValue(
      LocalStorageKeysEnum.IsLastRunDateSelected,
      isRunDateSelected ? 'true' : 'false'
    );
  }

  constructor(
    private readonly store: Store,
    private readonly localStorageService: LocalStorageService
  ) {
    const msPerDate = 24 * 60 * 60 * 1000;
    const now = new Date().getTime();
    const midnight = new Date().setHours(24, 0, 0, 0);
    const msToMidnight = midnight - now;

    timer(msToMidnight, msPerDate).subscribe(() => {
      this.midnightUpdateTrigger$.next(true);
    });
    this.store
      .select(getRunDatesLoaded)
      .pipe(
        filter((loaded) => loaded),
        switchMap(() => this.isReloaded$),
        observeOn(animationFrameScheduler)
      )
      .subscribe(() => {
        if (this.isLastRunDateSelected) {
          this.midnightUpdateTrigger$.next(false);
        }
      });

    this.store
      .select(getHourlyForecastRunDatesLoaded)
      .pipe(
        filter((loaded) => loaded),
        switchMap(() => this.isReloaded$),
        observeOn(animationFrameScheduler)
      )
      .subscribe(() => {
        if (this.isLastRunDateSelected) {
          this.midnightUpdateTrigger$.next(false);
        }
      });
  }
}
